import React, { useEffect, memo, useState } from 'react';
import Button from '../../components/Button';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import './HomePage.css'
import { useInjectReducer } from '../../utils/injectReducer';
import { useInjectSaga } from '../../utils/injectSaga';
import CenteredSection from './CenteredSection';
import { loadRepos } from '../App/actions';
import { changeUsername } from './actions';
import reducer from './reducer';
import saga from './saga';
const key = 'home';
import path from "../../constants/pathConstants";
import { getUrlParameter } from '../../constants/commonFunction';
import ErrorAlert from '../../components/ErrorAlert';
import logo from "../../images/CHASE_LOGO.svg"
import { useNavigate } from 'react-router-dom';

export function HomePage({
  username,
  loading,
  error,
  repos,
  onSubmitForm,
  onChangeUsername,
  redirectPath
}) {
  useInjectReducer({ key, reducer });
  useInjectSaga({ key, saga });
  const [modal, setModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalBody, setModalBody] = useState("");
  const toggle = () => setModal(!modal);

  const navigate = useNavigate();

  useEffect(() => {
    if (username && username.trim().length > 0) onSubmitForm();

    const param = getUrlParameter('err');
    if(param){
      setModalBody(param);
      toggle();
    }
  }, []);

  const loginRedirect = () => {
    navigate(path.MOBILE)
  }

  return (
    <article>
      <Helmet>
        <title>Home Page</title>
        <meta name="description" content="A React.js Boilerplate application homepage"/>
      </Helmet>
      <div  className="home-main">
        <CenteredSection>
          <img src={logo} alt="imgage" className="home-page-logo" />
          <div className='otpfield1-btn'>
            <Button onClick={()=>loginRedirect()}>Login</Button>
            <img style={{ margin: 'auto', paddingTop: '50px' }} src={require('../../images/Image.gif')} alt="imgage" className="imageContentMain" />
          </div>
        </CenteredSection>
        <ErrorAlert
          modal={modal}
          toggle={toggle}
          modalTitle={modalTitle}
          modalBody={modalBody}
        />
      </div>
    </article>
  );
}

HomePage.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  repos: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  onSubmitForm: PropTypes.func,
  username: PropTypes.string,
  onChangeUsername: PropTypes.func,
  redirectPath: PropTypes.func
};

const mapStateToProps = createStructuredSelector({
  // repos: makeSelectRepos(),
  // username: makeSelectUsername(),
  // loading: makeSelectLoading(),
  // error: makeSelectError(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onChangeUsername: evt => dispatch(changeUsername(evt.target.value)),
    onSubmitForm: evt => {
      if (evt !== undefined && evt.preventDefault) evt.preventDefault();
      dispatch(loadRepos());
    },
    redirectPath: (path) => dispatch(push(path))
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect, memo,)(HomePage);
